<style>
  .container-gauge{
    height: 300px;
  }
</style>
<template>
<div id="device-stadistics-view">
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-button :to="`/agro/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="vx-col w-full mb-base">
      <vs-tabs>
            <vs-tab :label="$t('Labels.State')" icon-pack="feather" icon="icon-list" @click="getResponse()">
              <vx-card
                  title="Últimas Lecturas">
                      <div style="width: 100%">
                        <a v-if="urlDownload.length > 0" class="btn-primary float-left" :href="urlDownload" download="LogEstado.csv"><feather-icon icon="DownloadCloudIcon" /></a>
                        <select class="vs-vs-inputx vs-input--input mb-3" v-model="log_limit" style="float: right; width: 90px;" @change="getResponse()">
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>

                    <vs-table v-if="response" ref="table" :data="response">
                    <template slot-scope="{data}">
                      <tbody>
                        <tr class="tr-values vs-table--tr tr-table-state-null selected" :key="indextr" v-for="(item, indextr) in data" >
                          <listItem
                            :value="item.created_at"
                            :description="$t('Labels.Date')"
                            img="fecha"
                          ></listItem>
                          <listItem
                            :value="item.created_at"
                            :description="$t('Labels.LastUpdated')"
                            img="clock"
                            :relativeTime="true"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.temp).toFixed(2)"
                            :description="$t('Labels.GroundTemperature')"
                            img="temperature"
                            unit="°C"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.atemp).toFixed(2)"
                            :description="$t('Labels.EnvTemperature')"
                            img="pressure"
                            unit="°C"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.ahum).toFixed(2)"
                            :description="$t('Labels.Humidity')"
                            img="humedad"
                            unit="%"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.rain_level).toFixed(2)"
                            :description="$t('Labels.Precipitation')"
                            img="lluvia"
                            unit="%"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.light_level).toFixed(2)"
                            :description="$t('Labels.Light')"
                            img="nivel_luz"
                            unit="%"
                          ></listItem>
                        </tr>
                      </tbody>
                    </template>
                  </vs-table>

              </vx-card>
            </vs-tab>
            <vs-tab :label="$t('Labels.InstantValues')" icon-pack="feather" icon="icon-activity" @click="getInfoGauges()">
              <vs-switch v-model="activeRefresh">
                <span slot="on">{{$t('Labels.Refresh')}}</span>
                <span slot="off">No {{$t('Labels.Refresh')}}</span>
              </vs-switch>
              <div class="flex mt-12" v-if="showGauges">
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.ahum.min"
                      :max="limits.ahum.max"
                      :alertMin="gauges.min_ahum"
                      :alertMax="gauges.max_ahum"
                      :title="$t('Labels.Humidity')"
                      :value="gauges.ahum"
                      unit="%"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.ground_hum.min"
                      :max="limits.ground_hum.max"
                      :alertMin="gauges.min_ground_hum"
                      :alertMax="gauges.max_ground_hum"
                      :title="$t('Labels.HumidityGround')"
                      :value="gauges.ground_hum"
                      unit="%"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                    <vx-card class="container-gauge">
                    <gauge
                      :min="limits.temp.min"
                      :max="limits.temp.max"
                      :alertMin="gauges.min_temp"
                      :alertMax="gauges.max_temp"
                      :title="$t('Labels.GroundTemperature')"
                      :value="gauges.temp"
                      unit="°C"
                    />
                  </vx-card>
                </div>
              </div>
              <div class="flex" v-if="showGauges">
                <div class="flex-1 p-4">
                    <vx-card class="container-gauge">
                    <gauge
                      :min="limits.atemp.min"
                      :max="limits.atemp.max"
                      :alertMin="gauges.min_atemp"
                      :alertMax="gauges.max_atemp"
                      :title="$t('Labels.EnvTemperature')"
                      :value="gauges.atemp"
                      unit="°C"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.rain_level.min"
                      :max="limits.rain_level.max"
                      :alertMin="gauges.min_rain_level"
                      :alertMax="gauges.max_rain_level"
                      :title="$t('Labels.Precipitation')"
                      :value="gauges.rain_level"
                      unit="%"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.light_level.min"
                      :max="limits.light_level.max"
                      :alertMin="gauges.min_light_level"
                      :alertMax="gauges.max_light_level"
                      :title="$t('Labels.Light')"
                      :value="gauges.light_level"
                      unit="%"
                    />
                  </vx-card>
                </div>
              </div>
            </vs-tab>
            <vs-tab :label="$t('Labels.Graphics')" icon-pack="feather" icon="icon-activity" @click="getCharts()">
              <div>{{$t('Labels.Today')}}</div>
              <div>
                <div class="flex" v-if="showAvg24">
                  <div class="flex-1 p-4">
                    <statistics
                      img="temperature"
                      :value="parseFloat(avg24.avg_tem || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_temp || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_temp || 0).toFixed(2)"
                      unit="°C"
                      :title="$t('Labels.GroundTemperature')"
                    />
                  </div>
                  <div class="flex-1 p-4">
                    <statistics
                      img="pressure"
                      :value="parseFloat(avg24.avg_atemp || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_atemp || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_atemp || 0).toFixed(2)"
                      unit="°C"
                      :title="$t('Labels.EnvTemperature')"
                    />
                  </div>
                </div>
                <div class="flex" v-if="showAvg24">
                  <div class="flex-1 p-4">
                    <statistics
                      img="humedad"
                      :value="parseFloat(avg24.avg_ahum || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_ahum || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_ahum || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.Humidity')"
                    />
                  </div>
                  <div class="flex-1 p-4">
                    <statistics
                      img="droplet"
                      :value="parseFloat(avg24.avg_ground_hum || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_ground_hum || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_ground_hum || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.HumidityGround')"
                    />
                  </div>
                </div>
                <div class="flex" v-if="showAvg24">
                  <div class="flex-1 p-4">
                    <statistics
                      img="lluvia"
                      :value="parseFloat(avg24.avg_rain_level || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_rain_level || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_rain_level || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.Precipitation')"
                    />
                  </div>
                  <div class="flex-1 p-4">
                    <statistics
                      img="nivel_luz"
                      :value="parseFloat(avg24.avg_light_level || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_light_level || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_light_level || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.Light')"
                    />
                  </div>

                </div>
              </div>
              <div>{{$t('Labels.Last24Hours')}}</div>
              <div class="flex" v-if="showAvg24">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticGroundTemperature',1)">
                    <apexchart v-if="temp.loaded" type="bar" height="350" :options="temp.options" :series="temp.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticEnvTemperature',1)">
                    <apexchart v-if="env.loaded" type="bar" height="350" :options="env.options" :series="env.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticHumidity',1)">
                    <apexchart v-if="hum.loaded" type="bar" height="350" :options="hum.options" :series="hum.data"></apexchart>
                  </vx-card>
                </div>
              </div>

              <div class="flex" v-if="showAvg24">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticPrecipitation',1)">
                    <apexchart v-if="rain.loaded" type="bar" height="350" :options="rain.options" :series="rain.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticLight',1)">
                    <apexchart v-if="light.loaded" type="bar" height="350" :options="light.options" :series="light.data"></apexchart>
                  </vx-card>
                </div>
              </div>
              <div>{{$t('Labels.LastWeek')}}</div>
              <div class="flex" v-if="showWeek">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticGroundTemperature',2)">
                    <apexchart v-if="tempToday.loaded" type="line" height="350" :options="tempToday.options" :series="tempToday.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticEnvTemperature',2)">
                    <apexchart v-if="envToday.loaded" type="line" height="350" :options="envToday.options" :series="envToday.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticHumidity',2)">
                    <apexchart v-if="humToday.loaded" type="line" height="350" :options="humToday.options" :series="humToday.data"></apexchart>
                  </vx-card>
                </div>
              </div>
              <div class="flex">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticGroundTemperature',2)">
                    <apexchart v-if="tempWeek.loaded" type="line" height="350" :options="tempWeek.options" :series="tempWeek.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticEnvTemperature',2)">
                    <apexchart v-if="envWeek.loaded" type="line" height="350" :options="envWeek.options" :series="envWeek.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticHumidity',2)">
                    <apexchart v-if="humWeek.loaded" type="line" height="350" :options="humWeek.options" :series="humWeek.data"></apexchart>
                  </vx-card>
                </div>
              </div>
              <div class="flex">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticPrecipitation',2)">
                    <apexchart v-if="rainWeek.loaded" type="line" height="350" :options="rainWeek.options" :series="rainWeek.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticLight',2)">
                    <apexchart v-if="lightWeek.loaded" type="line" height="350" :options="lightWeek.options" :series="lightWeek.data"></apexchart>
                  </vx-card>
                </div>
              </div>
            </vs-tab>
      </vs-tabs>
    </div>

  </div>

</div>

</template>

<script>

import apexchart from 'vue-apexcharts'
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import statistics from '@/components/statistics/statistics.vue'
import gauge from '@/components/gauge/gauge.vue'
import { empty } from '@/helpers.js'

export default {
  components: {
    apexchart,
    listItem,
    statistics,
    gauge
  },
  data () {
    return {
      response: [],
      log_limit: '5',
      uuid: this.$route.params.uuid,
      env: {
        data: [{ data: [], name: 'Temperatura ambiental' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} ft3/h`
              }
            }
          }
        }
      },
      temp: {
        data: [{ data: [], name: 'Temperatura del suelo' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}°`
              }
            }
          }
        }
      },
      hum: {
        data: [{ data: [], name: 'Humedad' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} pa`
              }
            }
          }
        }
      },
      light: {
        data: [{ data: [], name: 'Nivel de Luz' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} pa`
              }
            }
          }
        }
      },
      rain: {
        data: [{ data: [], name: 'Precipitación' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} pa`
              }
            }
          }
        }
      },
      envWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      tempWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      humWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      lightWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      rainWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      envToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      tempToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      humToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      lightToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      rainToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      options: {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        }
      },
      optionsToday: {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        }
      },
      urlDownload: '',
      avg24: {},
      avgWeek: {},
      showAvg24: false,
      showWeek: false,
      showToday: false,
      showGauges: false,
      gauges: [],
      limits: [],
      activeRefresh: false,
      doRefresh: {}
    }
  },
  methods: {
    async getResponse () {
      this.$vs.loading()

      this.showGauges = false
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false

      const params = {
        url: `modelo/agro/${this.uuid}/logs`,
        method: 'GET',
        params: {
          limit: this.log_limit
        }
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.$vs.loading.close()
        this.createCsv()
      })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getCharts () {
      this.showGauges = false
      this.getDayStatictics()
      this.getWeekStatistics()
      this.getTodayStatistics()
    },

    async getDayStatictics () {
      this.$vs.loading()

      const params = {
        url: `modelo/agro/${this.uuid}/stadistics_24`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.avg24 = response.data.data[0]
        if (response.data.data.length > 0) {
          this.env.data[0].data.push(parseFloat(response.data.data[0].min_temp).toFixed(2))
          this.env.data[0].data.push(parseFloat(response.data.data[0].avg_temp).toFixed(2))
          this.env.data[0].data.push(parseFloat(response.data.data[0].max_temp).toFixed(2))

          this.temp.data[0].data.push(parseFloat(response.data.data[0].min_atemp).toFixed(2))
          this.temp.data[0].data.push(parseFloat(response.data.data[0].avg_atemp).toFixed(2))
          this.temp.data[0].data.push(parseFloat(response.data.data[0].max_atemp).toFixed(2))

          this.hum.data[0].data.push(parseFloat(response.data.data[0].min_ahum).toFixed(2))
          this.hum.data[0].data.push(parseFloat(response.data.data[0].avg_ahum).toFixed(2))
          this.hum.data[0].data.push(parseFloat(response.data.data[0].max_ahum).toFixed(2))

          this.light.data[0].data.push(parseFloat(response.data.data[0].min_light_level).toFixed(2))
          this.light.data[0].data.push(parseFloat(response.data.data[0].avg_light_level).toFixed(2))
          this.light.data[0].data.push(parseFloat(response.data.data[0].max_light_level).toFixed(2))

          this.rain.data[0].data.push(parseFloat(response.data.data[0].min_rain_level).toFixed(2))
          this.rain.data[0].data.push(parseFloat(response.data.data[0].avg_rain_level).toFixed(2))
          this.rain.data[0].data.push(parseFloat(response.data.data[0].max_rain_level).toFixed(2))
        }
        this.env.loaded = true
        this.temp.loaded = true
        this.hum.loaded = true
        this.light.loaded = true
        this.rain.loaded = true
        this.showAvg24 = true
      }).catch(() => {
        this.env.data[0].data.push(0)
        this.env.data[0].data.push(0)
        this.env.data[0].data.push(0)

        this.temp.data[0].data.push(0)
        this.temp.data[0].data.push(0)
        this.temp.data[0].data.push(0)

        this.hum.data[0].data.push(0)
        this.hum.data[0].data.push(0)
        this.hum.data[0].data.push(0)
        this.light.data[0].data.push(0)
        this.light.data[0].data.push(0)
        this.light.data[0].data.push(0)

        this.rain.data[0].data.push(0)
        this.rain.data[0].data.push(0)
        this.rain.data[0].data.push(0)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getWeekStatistics () {
      this.$vs.loading()
      const params = {
        url: `modelo/agro/${this.uuid}/stadistics_week`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.tempWeek.label = []
        this.humWeek.label = []
        this.envWeek.label = []
        this.rainWeek.label = []
        this.lightWeek.label = []

        this.tempWeek.dataAvg = []
        this.tempWeek.dataMin = []
        this.tempWeek.dataMax = []

        this.humWeek.dataAvg = []
        this.humWeek.dataMin = []
        this.humWeek.dataMax = []

        this.envWeek.dataAvg = []
        this.envWeek.dataMin = []
        this.envWeek.dataMax = []

        this.rainWeek.dataAvg = []
        this.rainWeek.dataMin = []
        this.rainWeek.dataMax = []

        this.lightWeek.dataAvg = []
        this.lightWeek.dataMin = []
        this.lightWeek.dataMax = []

        response.data.data.forEach(function (item) {
          api.tempWeek.labels.push(item.day.split(' ')[0])
          api.tempWeek.dataAvg.push(parseFloat(item.avg_tem).toFixed(2))
          api.tempWeek.dataMin.push(parseFloat(item.min_temp).toFixed(2))
          api.tempWeek.dataMax.push(parseFloat(item.max_temp).toFixed(2))

          api.humWeek.labels.push(item.day.split(' ')[0])
          api.humWeek.dataAvg.push(parseFloat(item.avg_ahum).toFixed(2))
          api.humWeek.dataMin.push(parseFloat(item.min_ahum).toFixed(2))
          api.humWeek.dataMax.push(parseFloat(item.max_ahum).toFixed(2))

          api.envWeek.labels.push(item.day.split(' ')[0])
          api.envWeek.dataAvg.push(parseFloat(item.avg_atemp).toFixed(2))
          api.envWeek.dataMin.push(parseFloat(item.min_atemp).toFixed(2))
          api.envWeek.dataMax.push(parseFloat(item.max_atemp).toFixed(2))

          api.rainWeek.labels.push(item.day.split(' ')[0])
          api.rainWeek.dataAvg.push(parseFloat(item.avg_rain_level).toFixed(2))
          api.rainWeek.dataMin.push(parseFloat(item.min_rain_level).toFixed(2))
          api.rainWeek.dataMax.push(parseFloat(item.max_rain_level).toFixed(2))

          api.lightWeek.labels.push(item.day.split(' ')[0])
          api.lightWeek.dataAvg.push(parseFloat(item.avg_light_level).toFixed(2))
          api.lightWeek.dataMin.push(parseFloat(item.min_light_level).toFixed(2))
          api.lightWeek.dataMax.push(parseFloat(item.max_light_level).toFixed(2))
        })

        this.humWeek.data = [
          {
            name: 'Mínimo',
            data: this.humWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.humWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.humWeek.dataMax
          }
        ]
        this.tempWeek.data = [
          {
            name: 'Mínimo',
            data: this.tempWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.tempWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.tempWeek.dataMax
          }
        ]

        this.envWeek.data = [
          {
            name: 'Mínimo',
            data: this.envWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.envWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.envWeek.dataMax
          }
        ]

        this.rainWeek.data = [
          {
            name: 'Mínimo',
            data: this.rainWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.rainWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.rainWeek.dataMax
          }
        ]

        this.lightWeek.data = [
          {
            name: 'Mínimo',
            data: this.lightWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.lightWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.lightWeek.dataMax
          }
        ]

        this.humWeek.options = this.options
        this.humWeek.options.xaxis.categories = this.humWeek.labels

        this.tempWeek.options = this.options
        this.tempWeek.options.xaxis.categories = this.tempWeek.labels

        this.envWeek.options = this.options
        this.envWeek.options.xaxis.categories = this.envWeek.labels

        this.rainWeek.options = this.options
        this.rainWeek.options.xaxis.categories = this.rainWeek.labels

        this.lightWeek.options = this.options
        this.lightWeek.options.xaxis.categories = this.lightWeek.labels

        this.humWeek.loaded = true
        this.tempWeek.loaded = true
        this.envWeek.loaded = true
        this.rainWeek.loaded = true
        this.lightWeek.loaded = true

        this.$vs.loading.close()
        this.showWeek = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    async getTodayStatistics () {
      this.$vs.loading()
      const params = {
        url: `modelo/agro/${this.uuid}/stadistics_today`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.tempToday.label = []
        this.humToday.label = []
        this.envToday.label = []
        this.rainToday.label = []
        this.lightToday.label = []

        this.tempToday.dataAvg = []
        this.tempToday.dataMin = []
        this.tempToday.dataMax = []

        this.humToday.dataAvg = []
        this.humToday.dataMin = []
        this.humToday.dataMax = []

        this.envToday.dataAvg = []
        this.envToday.dataMin = []
        this.envToday.dataMax = []

        this.rainToday.dataAvg = []
        this.rainToday.dataMin = []
        this.rainToday.dataMax = []

        this.lightToday.dataAvg = []
        this.lightToday.dataMin = []
        this.lightToday.dataMax = []

        if (response.data.data.length > 0) {
          response.data.data.forEach(function (item) {
            api.tempToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
            api.tempToday.dataAvg.push(parseFloat(item.avg_tem).toFixed(2))
            api.tempToday.dataMin.push(parseFloat(item.min_temp).toFixed(2))
            api.tempToday.dataMax.push(parseFloat(item.max_temp).toFixed(2))

            api.humToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
            api.humToday.dataAvg.push(parseFloat(item.avg_ahum).toFixed(2))
            api.humToday.dataMin.push(parseFloat(item.min_ahum).toFixed(2))
            api.humToday.dataMax.push(parseFloat(item.max_ahum).toFixed(2))

            api.envToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
            api.envToday.dataAvg.push(parseFloat(item.avg_atemp).toFixed(2))
            api.envToday.dataMin.push(parseFloat(item.min_atemp).toFixed(2))
            api.envToday.dataMax.push(parseFloat(item.max_atemp).toFixed(2))

            api.rainToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
            api.rainToday.dataAvg.push(parseFloat(item.avg_rain_level).toFixed(2))
            api.rainToday.dataMin.push(parseFloat(item.min_rain_level).toFixed(2))
            api.rainToday.dataMax.push(parseFloat(item.max_rain_level).toFixed(2))

            api.lightToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
            api.lightToday.dataAvg.push(parseFloat(item.avg_light_level).toFixed(2))
            api.lightToday.dataMin.push(parseFloat(item.min_light_level).toFixed(2))
            api.lightToday.dataMax.push(parseFloat(item.max_light_level).toFixed(2))
          })

          this.humToday.data = [
            {
              name: 'Mínimo',
              data: this.humToday.dataMin
            },
            {
              name: 'Promedio',
              data: this.humToday.dataAvg
            },
            {
              name: 'Máximo',
              data: this.humToday.dataMax
            }
          ]
          this.tempToday.data = [
            {
              name: 'Mínimo',
              data: this.tempToday.dataMin
            },
            {
              name: 'Promedio',
              data: this.tempToday.dataAvg
            },
            {
              name: 'Máximo',
              data: this.tempToday.dataMax
            }
          ]

          this.envToday.data = [
            {
              name: 'Mínimo',
              data: this.envToday.dataMin
            },
            {
              name: 'Promedio',
              data: this.envToday.dataAvg
            },
            {
              name: 'Máximo',
              data: this.envToday.dataMax
            }
          ]

          this.rainToday.data = [
            {
              name: 'Mínimo',
              data: this.rainToday.dataMin
            },
            {
              name: 'Promedio',
              data: this.rainToday.dataAvg
            },
            {
              name: 'Máximo',
              data: this.rainToday.dataMax
            }
          ]

          this.lightToday.data = [
            {
              name: 'Mínimo',
              data: this.lightToday.dataMin
            },
            {
              name: 'Promedio',
              data: this.lightToday.dataAvg
            },
            {
              name: 'Máximo',
              data: this.lightToday.dataMax
            }
          ]

          this.humToday.options = this.options
          this.humToday.options.xaxis.categories = this.humToday.labels

          this.tempToday.options = this.options
          this.tempToday.options.xaxis.categories = this.tempToday.labels

          this.envToday.options = this.options
          this.envToday.options.xaxis.categories = this.envToday.labels

          this.rainToday.options = this.options
          this.rainToday.options.xaxis.categories = this.rainToday.labels

          this.lightToday.options = this.options
          this.lightToday.options.xaxis.categories = this.lightToday.labels

          this.humToday.loaded = true
          this.tempToday.loaded = true
          this.envToday.loaded = true
          this.rainToday.loaded = true
          this.lightToday.loaded = true
        }

        this.$vs.loading.close()
        this.showToday = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Date'))
      headers.push(this.$t('Labels.LastSeen'))
      headers.push(this.$t('Labels.GroundTemperature'))
      headers.push(this.$t('Labels.EnvTemperature'))
      headers.push(this.$t('Labels.Humidity'))
      headers.push(this.$t('Labels.Precipitation'))
      headers.push(this.$t('Labels.Light'))
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.created_at)
        row.push(this.relativeTimeConvert(item.created_at))
        row.push(`${item.temp}°C`)
        row.push(`${item.atemp}°C`)
        row.push(`${item.ahum}%`)
        row.push(`${item.rain_level}%`)
        row.push(`${item.light_level}%`)
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    },
    async getInfoGauges () {
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false
      this.$vs.loading()
      const params = {
        url: `modelo/agro/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.gauges = response.data.data
        this.limits = response.data.limits
        this.showGauges = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  created () {
    this.getResponse()
  },
  watch: {
    activeRefresh (val) {
      if (val) {
        const app = this
        let miliseconds = 0
        const units = {
          seconds: 1000,
          minutes: 60000,
          hours: 3600000
        }
        if (!empty(this.gauges.time) && !empty(this.gauges.time_unity)) { miliseconds = parseInt(this.gauges.time) * parseInt(units[this.gauges.time_unity]) } else { miliseconds = 11000 }

        this.doRefresh = setInterval(function () {
          app.getInfoGauges()
        }, miliseconds)
      } else {
        clearInterval(this.doRefresh)
      }
    }
  }

}
</script>
